// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_4f720283bf--tooltip--onAgf","content":"_4f720283bf--content--McDeU"};